// a react component that takes a sentence string and turns each element of the string into spans. Then it puts each word in to a div
// the first half of each word gets a bold class
// the second half of each word gets a normal class

import { nanoid } from "nanoid";

function ReactNDR({ text }: { text: string }) {
  const words = text.split(" ");
  const wordSpans = words.map((word) => {
    const firstHalf = word.slice(0, word.length / 2);
    const secondHalf = word.slice(word.length / 2);
    return (
      <span key={nanoid()}>
        <span className="neuro-divergent-letter-bold">{firstHalf}</span>
        <span>{secondHalf}</span>
        {"\xa0"}
      </span>
    );
  });
  return <div className="neuro-divergent-sentence">{wordSpans}</div>;
}

export default ReactNDR;
